import types from '../actionTypes';
// import tasks from '../tasks';

const initialState = {
	apiError: false,
	redirect: null,
	isTabletSize: false, // 1024px - 769px
	isMobileSize: false, // 768px and below
	// tasks,
};

function appReducer(state = initialState, action) {
	switch (action.type) {
		case types.SET_REDIRECT:
			return {
				...state,
				redirect: action.url,
			};
		case types.SET_DISPLAY_SIZE:
			const { size, status } = action;
			return {
				...state,
				isTabletSize: size === 'tablet' ? status : state.isTabletSize,
				isMobileSize: size === 'mobile' ? status : state.isMobileSize,
			};
		case types.SET_API_ERROR:
			return {
				...state,
				apiError: action.state,
			};
		default:
			return state;
	}
}

export default appReducer;
